export default __webpack_public_path__ + "static/media/exterior2_2020.9a2fb43d.jpeg";